module.exports = __webpack_public_path__ + "static/img/2.19c1f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/2.png
// module id = NxTx
// module chunks = 0